import { useQuery } from "@apollo/client"
import { GET_STORE_DETAIL } from "../queries/storeDetail"

interface UseStoreDetailOptions {
  skip?: boolean
}

export const useStoreDetail = (id: number, options: UseStoreDetailOptions = {}) => {
  const { data, loading, error, refetch } = useQuery(GET_STORE_DETAIL, {
    variables: { id },
    errorPolicy: "all",
    skip: !id || options.skip, // 👈 permite pausar la query si queremos
    fetchPolicy: "cache-and-network", // 👈 no hace doble request innecesario
  })

  return {
    store: data?.Store,
    loading,
    error,
    refetch,
  }
}
